export default "__VITE_ASSET__BjbqWRGc__"